import CartModel from '../model/Cart'
import store from '../store'
import { getDeviceType } from '../utils/device'

class CartFactory {
  // 创建新的购物车
  static create (data = {}) {
    const model = new CartModel(data)
    model.sorce = getDeviceType()
    return model
  }

  // 本地保存
  static save ({ cart }) {
    store.dispatch('saveCart', { cart })
  }

  // 本地获取
  static getCurrentCart () {
    return store.getters.cart || null
  }
}

export default CartFactory
